import React from "react";
import { Alert } from "@material-ui/lab";
import { makeStyles, Typography } from "@material-ui/core";

import { Link } from "react-router-dom";

import useAccountMetadata from "../hooks/useAccountMetadata";
import { BlockerStatus } from "./types";
import useTrackerBlockingStaleness from "./useTrackerBlockingStaleness";
import useWTMURLs from "./useWTMURLs";

const useStyles = makeStyles((_) => ({
  link: {
    textDecoration: "underline",
    fontWeight: "bold",
  },
}));

function BlockerStalenessBanner() {
  const accountMetadata = useAccountMetadata();
  if (
    !accountMetadata?.loaded ||
    !accountMetadata?.config["webTrackerMonitoringTrackerBlockedUI"]
  ) {
    return null;
  }

  return <BlockerStalenessBannerInner />;
}

function BlockerStalenessBannerInner() {
  const classes = useStyles();
  const { staleness, isLoading } = useTrackerBlockingStaleness();
  const wtmURLs = useWTMURLs();

  if (isLoading) {
    return null;
  }

  switch (staleness) {
    case BlockerStatus.CHANGES_PENDING:
      return (
        <Alert severity="warning">
          <Typography variant="body1">
            Tracker blocker has unpublished changes. Publish the changes on the{" "}
            <Link className={classes.link} to={wtmURLs.trackerBlocking}>
              tracker blocking page here.
            </Link>
          </Typography>
        </Alert>
      );
    case BlockerStatus.DISABLED:
      return (
        <Alert severity="error">
          <Typography variant="body1">
            Tracker blocker is disabled! Third party web trackers may be
            collecting PHI on your site. Enable the tracker blocker on the{" "}
            <Link className={classes.link} to={wtmURLs.trackerBlocking}>
              tracker blocking page here.
            </Link>
          </Typography>{" "}
        </Alert>
      );
    case BlockerStatus.UP_TO_DATE:
    default:
      return null;
  }
}

export default BlockerStalenessBanner;
